import { render, staticRenderFns } from "./AppUpdateNotifications.vue?vue&type=template&id=400c95fa&scoped=true&"
import script from "./AppUpdateNotifications.vue?vue&type=script&lang=js&"
export * from "./AppUpdateNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AppUpdateNotifications.vue?vue&type=style&index=0&id=400c95fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400c95fa",
  null
  
)

export default component.exports